<template>
    <div>
      <Head title="Credit Notes Queue" />
      <h1 class="mb-8 text-3xl font-bold">Credit Notes Queue</h1>
      <div class="flex items-center justify-between mb-6">
        <search-with-date-range v-model="search.search" class="mr-0 w-full max-w-md mr-3" @reset="resetSearch" />
        <date-range v-model="search.dateValue" class="mr-0 w-full max-w-md" @reset="reset" />
      </div>
      <div v-if="orders.data && url()" class="bg-white rounded-md shadow overflow-x-auto p-5 mb-5">
        <div class="flex items-center justify-between">
          <a
            class="btn-orange px-3 py-2 text-xs cursor-pointer"
            :href="`/returned-grns/downloads${url()}`" 
            download
            target="__blank"
            title="Download"
          >
            <span>Download</span>
          </a>
        </div>
      </div>
      <div class="bg-white rounded-md shadow overflow-x-auto">
        <table class="w-full whitespace-nowrap">
          <tr class="text-left font-bold">
            <th class="pb-3 pt-3 px-3">Date</th>
            <th class="pb-3 pt-3 px-3">GRN Number</th>
            <th class="pb-3 pt-3 px-3">Credit Note Number</th>
            <th class="pb-3 pt-3 px-3">Order Number</th>
            <th class="pb-3 pt-3 px-3">Invoice Number</th>
            <th class="pb-3 pt-3 px-3">Customer</th> 
            <th class="pb-3 pt-3 px-3">Region</th>
            <th class="pb-3 pt-3 px-3">City</th>
            <th class="pb-3 pt-3 px-3">Action</th>
          </tr>
          <tr v-for="list in orders.data" :key="list.id" class="hover:bg-orange-100 focus-within:bg-gray-100">
            <td class="border-t">
              <Link class="flex items-center px-3 py-3 focus:text-orange-500" href="#" title="">
                {{ list.date }}
              </Link>
            </td>
            <td class="border-t">
              <Link class="flex items-center px-3 py-3 focus:text-orange-500" href="#" title="">
                {{ list.number }}
              </Link>
            </td>
            <td class="border-t">
              <Link class="flex items-center px-3 py-3 focus:text-orange-500" href="#" title="">
                {{ list.credit_note_number }}
              </Link>
            </td>
            <td class="border-t">
              <Link class="flex items-center px-3 py-3 focus:text-orange-500" href="#" title="">
                {{ list.order_no }}
              </Link>
            </td>
            <td class="border-t">
              <Link class="flex items-center px-3 py-3 focus:text-orange-500" href="#" title="">
                {{ list.invoice_number }}
              </Link>
            </td>
            <td class="border-t">
              <Link class="flex items-center px-3 py-3 focus:text-orange-500" href="#" title="">
                {{ list.customer }}
              </Link>
            </td>
            <td class="border-t">
              <Link class="flex items-center px-3 py-3 focus:text-orange-500" href="#" title="">
                {{ list.region }}
              </Link>
            </td>
            <td class="border-t">
              <Link class="flex items-center px-3 py-3 focus:text-orange-500" href="#" title="">
                {{ list.city }}
              </Link>
            </td>
            <td class="border-t">
                <button @click="validateGrn(list)" class="btn-orange p-0 m-0 p-1 pl-3 pr-3">
                    Validate GRN
                </button>
            </td>
          </tr>
          <tr v-if="orders.data.length === 0">
            <td class="px-3 py-3 border-t" colspan="10">No data found</td>
          </tr>
        </table>
      </div>
      <br>
      <pagination class="mt-6" :links="orders.links" />
    </div>
  </template>
        
  <script>
  import { Head, Link } from '@inertiajs/inertia-vue3'
  import pickBy from 'lodash/pickBy'
  import Layout from '@/Shared/Layout'
  import throttle from 'lodash/throttle'
  import mapValues from 'lodash/mapValues'
  import SearchWithDateRange from '@/Shared/SearchWithDateRange'
  import Pagination from '@/Shared/Pagination'
  import DateRange from '@/Shared/DateRange'
  import { router } from '@inertiajs/inertia-vue3'
        
  export default {
    components: {
      Head,
      Link,
      SearchWithDateRange,
      Pagination,
      DateRange,
    },
    layout: Layout,
    props: {
      filters: Object,
      orders: Object,
    },
    data() {
      return {
        search: {
          search: this.filters.search,
          dateValue: this.filters.dateValue,
        },
      }
    },
    watch: {
      search: {
        deep: true,
        handler: throttle(function () {
          this.$inertia.get('/credit-notes-queue', pickBy(this.search), { preserveState: true })
        }, 150),
      },
    },
    methods: {
      reset() {
        this.search = mapValues(this.search, () => null)
      },
      url() {
        let query = '';
        if (this.search.search) {
          if (query) {
            query += '&';
          }
          query += `search=${this.search.search}`;
        }
        if (this.search.dateValue) {
          if (query) {
            query += '&';
          }
          query += `dateValue=${this.search.dateValue}`;
        }
        if (query) {
          query = `?${query}`;
        }
        return query;
      },
      validateGrn(item) {
        if (confirm('Are you sure you want to validate this GRN?')) {
            this.$inertia.post('/validate-grn', {grn_no: item.id})
        }
      },
    },
  }
  </script>
        